import { styled } from '@styles/stitches';
import { IconButton } from '@versumstudios/ui';

export const Label = styled('label', {
  display: 'inline-flex',
  alignItems: 'center',
  color: '$secondaryFill',
  fontSize: 14,
  cursor: 'pointer',

  [`& ${IconButton}`]: {
    marginRight: 8,
  },
});
